import CopyToClipboard from "@client/controls/CopyToClipboard/component";
import Icon from "@client/controls/Icon/component";
import { type WithI18n, type WithId } from "@client/types";
import Accordion from "@common/controls/Accordion";
import { IconType } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { type MemberAffiliate } from "../types";

export type MapProps = WithId & {
  offers: MemberAffiliate.Offer[];
};

export interface ActionProps {}

const Link = (props: ActionProps & MemberAffiliate.OfferPage & WithI18n) => {
  const i18n = useI18n();

  return (
    <span className="link_item">
      <Icon iconClassName={IconType.Link} />
      <span className="link">{props.absoluteUrl}</span>

      <CopyToClipboard hideInput text={props.absoluteUrl}>
        <Icon iconClassName={IconType.Copy} />
        {i18n.copyLink}
      </CopyToClipboard>
    </span>
  );
};

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return !!props.offers.length ? (
    <Accordion className="cartly_member">
      {props.offers.map((s) => (
        <Accordion.Item key={s.id} label={s.name}>
          <p dangerouslySetInnerHTML={{ __html: s.description }} />
          <h5>{i18n.affiliateLinks}</h5>
          {s.pages.map((p) => (
            <Link {...p} key={p.absoluteUrl} />
          ))}
        </Accordion.Item>
      ))}
    </Accordion>
  ) : (
    <div>You currently have no offers</div>
  );
};
